export default [
  {
    path: '/dredgeScanCollection', name: 'dredgeScanCollection', component: () => import('@/pages/merchant/dredgeScanCollection'), meta: { title: '商户信息' },
  },
  {
    path: '/merchantDataDetail', name: 'merchantDataDetail', component: () => import('@/pages/merchant/merchantDataDetail'), meta: { title: '商户信息' },
  },
  {
    path: '/dredgeScanCollectionDetail', name: 'dredgeScanCollectionDetail', component: () => import('@/pages/merchant/dredgeScanCollectionDetail'), meta: { title: '商户信息' },
  },
  {
    path: '/wxScanAuthentication', name: 'wxScanAuthentication', component: () => import('@/pages/merchant/wxScanAuthentication'), meta: { title: '商户信息' },
  },
  {
    path: '/updateSettlementInfo', name: 'updateSettlementInfo', component: () => import('@/pages/merchant/updateSettlementInfo'), meta: { title: '商户信息' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/merchant.js